import React from 'react';
import { amazonPriceIsExpired, isAmazonApiOffer } from '../../domain/amazonPricePolicy';

export default function AmazonPriceNotice({ offers = [] }) {
  const quotes = offers.filter((offer) => isAmazonApiOffer(offer) && !amazonPriceIsExpired(offer)
    && Number(offer.current_price ?? offer.numeric_price) > 0);
  if (!quotes.length) return null;
  const checkedAt = new Date(Math.min(...quotes.map((offer) =>
    new Date(offer.last_success_at || offer.last_checked_at || offer['Date Time Stamp']).getTime())));
  return (
    <div data-testid="amazon-price-notice" style={{ fontSize: '0.75rem', lineHeight: 1.5, marginTop: '1rem' }}>
      <p>Amazon price checked {checkedAt.toLocaleString(undefined, { timeZoneName: 'short' })}.</p>
      <details>
        <summary>Amazon pricing details</summary>
        <p>Product prices and availability are accurate as of the date/time indicated and are subject to change.
          Any price and availability information displayed on Amazon.com at the time of purchase will apply to the purchase of this product.</p>
      </details>
      <p>CERTAIN CONTENT THAT APPEARS ON THIS SITE COMES FROM AMAZON.
        THIS CONTENT IS PROVIDED ‘AS IS’ AND IS SUBJECT TO CHANGE OR REMOVAL AT ANY TIME.</p>
    </div>
  );
}
